import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as analyticsAppActions from '../store/actions/analytics-app-actions';
import AnalyticsGrid from '../components/analytics-grid/AnalyticsGrid';
import FormSpinner from '../../sso/components/common/utility/FormSpinner';
import { AnalyticsAppContext } from '../context/analytics-app-context';
import AnalyticsViewMessage from '../components/analytics-view-message/AnalyticsViewMessage';
import { getFormattedNowDate } from '../utils/date-utils';
import { isEmpty } from '../utils/object-utils';
import {
    setDateToFilterBy,
    setDateRangeFilters,
    removeDateRangeFilters,
    removeDateToFilterBy,
    removeShowLatestData,
    setShowLatestData
} from '../store/actions/utils/url-utils';

class CustomAnalyticsAppComponent extends Component {
    constructor(props) {
        super(props);

        this.loadAnalyticsAppData = this.loadAnalyticsAppData.bind(this);
        this.filterAnalyticsDataByDate = this.filterAnalyticsDataByDate.bind(this);
        this.filterAnalyticsDataByDateRange = this.filterAnalyticsDataByDateRange.bind(this);
        this.displayLatestData = this.displayLatestData.bind(this);
        this.clearAnalyticsFilters = this.clearAnalyticsFilters.bind(this);
        this.updateLoadingState = this.updateLoadingState.bind(this);
        this.updateAppContextState = this.updateAppContextState.bind(this);
        this.updateSomethingWentWrongState = this.updateSomethingWentWrongState.bind(this);
        const { analyticsPageProperties } = props;
        this.state = {
            appContext: {
                loading: false,
                domain: analyticsPageProperties.domain,
                formattedTodayDate: getFormattedNowDate(),
                loadAnalyticsAppData: this.loadAnalyticsAppData,
                filterAnalyticsDataByDate: this.filterAnalyticsDataByDate,
                filterAnalyticsDataByDateRange: this.filterAnalyticsDataByDateRange,
                displayLatestData: this.displayLatestData,
                clearAnalyticsFilters: this.clearAnalyticsFilters,
                analyticsData: {},
                datesToFilter: [],
                allAvailableDates: []
            },
            somethingWentWrong: false
        };
    }

    componentDidMount() {
        this.loadAnalyticsAppData();
    }

    componentDidCatch() {
        this.setState((prevState) => {
            return { ...prevState, somethingWentWrong: true };
        });
    }

    componentWillReceiveProps(nextProps) {
        const { loading, isAnalyticsDataLoadedSuccessfully, analyticsData } = nextProps;
        const { formattedAnalyticsData, datesToFilter } = analyticsData;
        const hasLoadedSuccessfully = isAnalyticsDataLoadedSuccessfully && !isEmpty(analyticsData);
        const hasAnalyticsDataChanged = JSON.stringify(this.state.analyticsData) !== JSON.stringify(formattedAnalyticsData);

        if (loading !== this.state.appContext.loading) {
            this.updateLoadingState(loading);
        }

        if (!loading && hasLoadedSuccessfully && hasAnalyticsDataChanged) {
            this.updateAppContextState({ formattedAnalyticsData, datesToFilter });
        }

        if (!loading && !hasLoadedSuccessfully) {
            this.updateSomethingWentWrongState(true);
        }
    }

    updateLoadingState(loading) {
        this.setState((prevState) => {
            return {
                ...prevState,
                appContext: {
                    ...prevState.appContext,
                    loading
                }
            };
        });
    }

    updateAppContextState({ formattedAnalyticsData, datesToFilter }) {
        this.setState((prevState) => {
            return {
                ...prevState,
                somethingWentWrong: false,
                appContext: {
                    ...prevState.appContext,
                    analyticsData: formattedAnalyticsData,
                    datesToFilter
                }
            };
        });
    }

    updateSomethingWentWrongState(somethingWentWrong) {
        this.setState((prevState) => {
            return {
                ...prevState,
                somethingWentWrong
            };
        });
    }

    loadAnalyticsAppData(datefilter) {
        const { analyticsPageProperties } = this.props;
        let dateQuery = '&date';
        let finalDateFrom = new Date();
        let finalDateTo = new Date();
        if (datefilter) {
            const keys = Object.keys(datefilter);
            if (keys.length > 1) {
                const dateFromParam = new Date(+datefilter.from + 1000 * 3600);
                const dateToParam = new Date(+datefilter.to + 1000 * 3600);

                if (dateFromParam > dateToParam) {
                    finalDateFrom = dateToParam;
                    finalDateTo = dateFromParam;
                } else {
                    finalDateFrom = dateFromParam;
                    finalDateTo = dateToParam;
                }

                dateQuery = dateQuery + 'From=' + finalDateFrom.getDate() + ' ' + (finalDateFrom.getMonth() + 1) + ' ' + finalDateFrom.getFullYear() +
                    '&dateTo=' + finalDateTo.getDate() + ' ' + (finalDateTo.getMonth() + 1) + ' ' + finalDateTo.getFullYear();

            }
            else {
                const dateParam = new Date(+datefilter + 1000 * 3600)
                dateQuery = dateQuery + 'Filter=' + dateParam.getDate() + ' ' + (dateParam.getMonth() + 1) + ' ' + dateParam.getFullYear();
            }
            this.props.actions.loadAnalyticsAppData(analyticsPageProperties.callBackUrl + dateQuery);
        } else { this.props.actions.loadAnalyticsAppData(analyticsPageProperties.callBackUrl + dateQuery); }
    }

    displayLatestData(showLatestData) {
        removeDateRangeFilters();
        removeDateToFilterBy();
        setShowLatestData(showLatestData);
        this.loadAnalyticsAppData();
    }

    filterAnalyticsDataByDate(dateToFilterBy) {
        removeDateRangeFilters();
        removeShowLatestData();
        setDateToFilterBy(dateToFilterBy);
        this.loadAnalyticsAppData(dateToFilterBy);
    }

    filterAnalyticsDataByDateRange(dateRange) {
        removeDateToFilterBy();
        removeShowLatestData();
        setDateRangeFilters(dateRange);
        this.loadAnalyticsAppData(dateRange);
    }

    clearAnalyticsFilters() {
        removeDateRangeFilters();
        removeDateToFilterBy();
        removeShowLatestData();
        this.loadAnalyticsAppData();
    }

    render() {
        const { loading } = this.props;
        const { appContext, somethingWentWrong } = this.state;

        return (
            <AnalyticsAppContext.Provider value={appContext}>
                {loading && <FormSpinner>/</FormSpinner>}
                <div className='analytics-page-container'>
                    {somethingWentWrong && <AnalyticsViewMessage message={'Something went wrong!'}></AnalyticsViewMessage>}
                    {!somethingWentWrong && <AnalyticsGrid ></AnalyticsGrid>}
                </div>
            </AnalyticsAppContext.Provider >
        );
    }
}

CustomAnalyticsAppComponent.propTypes = {
    analyticsPageProperties: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isAnalyticsDataLoadedSuccessfully: state.analytics.isAnalyticsDataLoadedSuccessfully,
        analyticsData: state.analytics.analyticsData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            loadAnalyticsAppData: bindActionCreators(analyticsAppActions.loadAnalyticsAppData, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomAnalyticsAppComponent);
